import React from 'react';
import BaseComponent from './Base';

class Accounts extends BaseComponent {
    constructor(props) {
      let config = {
        subModuleName : "accounts",
        filterParams:[]
      };

      super(props, config);
    }
    //تبدیل آی پی به عدد
    inet_aton(ip) {
      // split into octets
      var a = ip.split('.');
      var buffer = new ArrayBuffer(4);
      var dv = new DataView(buffer);
      for (var i = 0; i < 4; i++) {
        dv.setUint8(i, a[i]);
      }
      return (dv.getUint32(0));
    }
    // تبدیل عدد به آی پی
    inet_ntoa(num) {
      var nbuffer = new ArrayBuffer(4);
      var ndv = new DataView(nbuffer);
      ndv.setUint32(0, num);

      var a = new Array();
      for (var i = 0; i < 4; i++) {
        a[i] = ndv.getUint8(i);
      }
      return a.join('.');
    }
    componentWillReceiveProps(props){
      this.state.data = null;
      this.refresh();
    }
    hasCivilicaAccess(record,type){
      if (record.civilica_access_type.includes("[" + type + "]"))
        return <i class="fal fa-check text-green"></i>

      return <i class="fal fa-ban text-red"></i>
    }
    hasISIAccess(record,type){
      if (record.isi_access_type.includes("[" + type + "]"))
        return <i class="fal fa-check text-green"></i>

      return <i class="fal fa-ban text-red"></i>
    }
    renderListView(){
      return (
        <div>
          {this.state.data.records.length > 0 ?
            <div className="row">
              {this.state.data.records.map(_t=>
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className="box box-success">
                    <div className="box-header with-border">
                      <h3 className="box-title" style={{"display":"block"}}>
                          {this.getAccessTitle(_t)}
                          {_t.credit>0 ?
                            <span className="label label-info pull-left mr-r-5">{_t.credit} اعتبار</span>
                          :null}
                          {_t.limit_dl_to_ip === 1 ?
                            <span className="label label-danger pull-left mr-r-5">دانلود فایل مقالات فقط از طریق آی پی</span>
                          :null}
                          {_t.CivilicaAccessDate !== null ?
                            <span className="label label-warning pull-left mr-r-5">انقضا دسترسی {this.g2j(_t.CivilicaAccessDate)}</span>
                          :null}                          
                      </h3>
                    </div>
                    <div className="box-body">
                      <ul className="products-list product-list-in-box">
                        {_t.Description !== null && _t.Description !== "" ?
                          <div className="item">
                            <p className="message">متن راهنمای کاربران این مرکز:</p>
                            <p className="message" dangerouslySetInnerHTML={{__html: _t.Description}}></p>
                          </div>
                        :null}
                        <div className="item">
                          <div className="col-md-3 col-sm-2 col-xs-6">دسترسی ها به مقالات داخلی</div>
                          <div className="col-md-1 col-sm-2 col-xs-6">{this.hasCivilicaAccess(_t,3)} مستقیم</div>
                          <div className="col-md-1 col-sm-2 col-xs-6">{this.hasCivilicaAccess(_t,1)} آی پی</div>
                          <div className="col-md-1 col-sm-2 col-xs-6">{this.hasCivilicaAccess(_t,2)} وبسرویس</div>
                          <div className="col-md-1 col-sm-2 col-xs-6">{this.hasCivilicaAccess(_t,5)} موبایل</div>
                          <div className="col-md-1 col-sm-2 col-xs-6">{this.hasCivilicaAccess(_t,4)} ایمیل</div>
                        </div>
                        <div className="item">
                          <div className="col-md-3 col-sm-2 col-xs-6">دسترسی ها به مقالات بین المللی</div>
                          <div className="col-md-1 col-sm-2 col-xs-6">{this.hasISIAccess(_t,3)} مستقیم</div>
                          <div className="col-md-1 col-sm-2 col-xs-6">{this.hasISIAccess(_t,1)} آی پی</div>
                          <div className="col-md-1 col-sm-2 col-xs-6">{this.hasISIAccess(_t,2)} وبسرویس</div>
                          <div className="col-md-1 col-sm-2 col-xs-6">{this.hasISIAccess(_t,5)} موبایل</div>
                          <div className="col-md-1 col-sm-2 col-xs-6">{this.hasISIAccess(_t,4)} ایمیل</div>
                        </div>                
                        <div className="item">
                          {_t.api_max_request > 0 ?
                            <div className="col-md-12 col-sm-12 col-xs-12">
                              <span className="label label-success pull-right mr-l-5">
                                دریافت روزانه وب سرویس {_t.api_max_request} مقاله
                              </span>
                            </div>
                          :null}
                          {_t.mobile_no > 0 ?
                            <div className="col-md-12 col-sm-12 col-xs-12">
                              <span className="label label-success pull-right mr-l-5">
                                دریافت با دسترسی موبایل {_t.mobile_no} مقاله در هر {_t.mobile_hour} ساعت
                              </span>
                            </div>
                          :null}
                          {_t.ip_other_email_no > 0 ?
                            <div className="col-md-12 col-sm-12 col-xs-12">
                              <span className="label label-success pull-right mr-l-5">
                                دریافت ایمیل های خارج از مرکز {_t.ip_other_email_no} مقاله در هر {_t.ip_other_email_hour} ساعت
                              </span>
                            </div>
                          :null}
                          {JSON.parse(_t.sub_domain_configs).length > 0 ?
                            <div className="col-md-12 col-sm-12 col-xs-12">
                              {JSON.parse(_t.sub_domain_configs).map(_sub=>
                                <span className="label label-warning pull-right mr-l-5">
                                  دریافت از دامین {_sub.domain} , {_sub.no} مقاله در هر {_sub.hour} ساعت
                                </span>
                              )}
                            </div>
                          :null}
                        </div>
                        {_t.IPs.length>0 ?
                          <div className="item">
                            <p className="message">آی پی های مجاز این مرکز جهت دسترسی به مقالات</p>
                            {_t.IPs.map(_ip=>
                                <span className="label label-info pull-left mr-r-5">
                                  {_ip.from_ip === _ip.to_ip ?
                                    this.inet_ntoa(_ip.from_ip)
                                  :
                                    this.inet_ntoa(_ip.from_ip) + "  -  " + this.inet_ntoa(_ip.to_ip)
                                  }
                                </span>
                            )}
                          </div>
                        :null}
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>
          :
            <h4 className="alert alert-info text-center">در حال حاضر هیچ نوع مدل دسترسی به مقالات پایگاه سیویلیکا برای مرکز شما ثبت نشده است.</h4>
          }
        </div>
      );
    }
    render() {
      if (this.state.data === null || this.state.data === undefined)
        return this.showLoading();
      if (this.state.data.status === 500 || this.state.data.status === 0)
        return this.render500()
      if (this.state.data.status === 404)
        return this.render404()
      if (this.state.data.status === 2)
        return this.renderNoAccess()
      if (this.state.data.status === 4)
        return this.renderNoLogin();
      return this.renderListView();
    }
  }
  export default Accounts;